import Vue from 'vue'

import Lazy from '~/custom/vue-vanilla-lazyload'
Vue.use(Lazy)
